import { useAppNavigate, useTeam, useTeamTasks, useTeamDocumentTitle, useSimulationStatus } from '../../hooks';

import { QueryResult } from '../molecules';
import { Page, TasksList } from '../organisms';

export function TasksPage() {
  const navigate = useAppNavigate();
  const team = useTeam();
  const teamTasks = useTeamTasks(team.name);
  const simulationStatus = useSimulationStatus();

  // Update browser tab title with team name
  useTeamDocumentTitle(team.name);

  return (
    <Page title={null}>
      <QueryResult
        query={teamTasks}
        renderAs={(data) => (
          <TasksList
            team={team}
            tasks={data}
            onTaskClick={(task) => {
              navigate.toTask(task);
            }}
            simulationState={simulationStatus.state}
          />
        )}
      />
    </Page>
  );
}
